<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-subheader class="primary headline white--text" style="width: 100%">
        Check-ins
      </v-subheader>
      <v-card-text>
        <v-card-subtitle class="pt-4" v-if="!attendees">No checkins yet</v-card-subtitle>
        <v-simple-table v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left"></th>
                <th class="text-left">Name</th>
                <th class="text-left">Date</th>
                <th class="text-left">Location</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, key) in attendees" :key="key">
                <td>
                  <v-avatar size="40">
                    <v-img
                      :src="getImageUrlById(key) || require('@/assets/profile_pic_empty.png')"
                    ></v-img>
                  </v-avatar>
                </td>
                <td>{{ userShortName(key) }}</td>
                <td>{{ item.timestamp | toDate("p") }}</td>
                <td>
                  <v-btn
                    icon
                    :href="`http://www.google.com/maps/place/${item.location.latitude},${item.location.longitude}`"
                    ><v-icon>mdi-open-in-new</v-icon></v-btn
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-show="attendees" text color="primary" @click="downloadXLS"
          ><v-icon left>mdi-download</v-icon>Download</v-btn
        >
        <v-btn color="primary" @click="dialog = false">{{ $t("common.close") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const Excel = require("exceljs");

export default {
  props: ["name", "attendees"],
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    downloadXLS() {
      const workbook = new Excel.Workbook();
      const worksheet = workbook.addWorksheet("Check-ins");

      worksheet.columns = [
        { header: "Name", key: "name", width: 15 },
        { header: "Email", key: "email", width: 20 },
        { header: "Date", key: "date", width: 10 },
        { header: "Location", key: "location", width: 30 },
        // { header: 'Registro', key: 'reg', width: 32 }
      ];

      Object.keys(this.$props.attendees).forEach((userId) => {
        const user = this.$store.getters.getUserById(userId);
        const attendeeData = this.$props.attendees[userId];
        worksheet.addRow([
          user.name,
          user.email,
          attendeeData.timestamp.toDate(),
          `${attendeeData.location.latitude},${attendeeData.location.longitude}`,
        ]);
      });

      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = `${this.$props.name} checkins.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
      });
    },
    userShortName(id) {
      return this.$store.getters.userShortName(id);
    },
    getImageUrlById(id) {
      return this.$store.getters.getImageUrlById(id);
    },
  },
};
</script>
